import { useContext } from "react";
import { CartContext, type CartContextValue } from "./cart-context";

/**
 * Hook to access cart context for adding items.
 * Must be used within a CartProvider.
 *
 * For fetching cart data, use `useSellerCarts()` from `@/queries/cart` instead.
 *
 * @example
 * ```tsx
 * const { addToCart, isAddingToCart } = useCartContext();
 *
 * const handleAddToCart = async () => {
 *   await addToCart({ offer_id: "soff_123", quantity: 2 });
 *   toast.success("Added to cart!");
 * };
 * ```
 */
export function useCartContext(): CartContextValue {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error("useCartContext must be used within a CartProvider");
  }

  return context;
}
